<template>
  <div>
    <div class="loader" v-if="isLoading"></div>
    <div class="req-group" v-else>
      <div class="req-questions">
        <div class="req-question-group">
          <div class="req-question-title">1. Name of event</div>
          <input class="req-control" type="text" v-model="name" />
        </div>
        <div class="req-question-group">
          <div class="req-question-title">2. Type of event</div>
          <select v-model="type.model" class="req-control">
            <option
              v-for="(option, optionIdx) in type.options"
              :key="optionIdx"
              >{{ option }}</option
            >
          </select>
        </div>
        <div class="req-question-group">
          <div class="req-question-title">3. For user types</div>
          <div style="padding:5px;">
            <label class="checkbox">
              All
              <input type="checkbox" v-model="userTypeAll" />
              <span class="checkmark"></span>
            </label>
          </div>
          <template v-for="(userType, i) in userTypes">
            <div style="padding:5px;" :key="i">
              <label class="checkbox">
                {{ userType.text }}
                <input type="checkbox" v-model="userType.checked" />
                <span class="checkmark"></span>
              </label>
            </div>
          </template>
        </div>
        <div class="req-question-group">
          <div class="req-question-title">4. Departments</div>
          <template v-for="(department, k) in departments">
            <div class="checkbox-group-with-sub" :key="k">
              <label class="checkbox">
                {{ k }}
                <input type="checkbox" v-model="department.checked" />
                <span class="checkmark"></span>
              </label>
              <template v-for="(content, i) in department.contents">
                <div :key="i" style="margin-left:10px;">
                  <label class="checkbox">
                    {{ content.text }}
                    <input type="checkbox" v-model="content.checked" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </template>
            </div>
          </template>
        </div>
        <div class="req-question-group column">
          <div class="req-question-title">
            5. Select a date you want the event to take place
          </div>
          <CalendarPicker
            ref="picker"
            :selectedDays.sync="dates.model"
            :enableWeekends="true"
            :enableEvents="true"
          ></CalendarPicker>
        </div>
      </div>
      <div class="footer" v-if="isNew()">
        <div class="loader" v-if="isSubmitting"></div>
        <button class="button green" @click="submit" v-else>ADD EVENT</button>
      </div>
      <div class="footer" v-else>
        <div class="loader" v-if="isSubmitting"></div>
        <div style="display:flex" v-else>
          <button
            class="button red"
            style="margin-right:10px"
            @click="deleteEvent"
          >
            Delete
          </button>
          <button class="button green-bg" @click="updateEvent">Update</button>
        </div>
      </div>
      <Notif v-if="notif" :data.sync="notif" />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { http, utils } from '../digilib_web/core/digitify';
import { constants } from '../js/regents';
import CalendarPicker from './common/calendar_picker';
import Notif from '../digilib_web/vue/notif';

export default {
  props: {
    id: Number,
    events: Array
  },
  mounted() {
    this.currentYear = dayjs().format('YYYY');
    // clone the event on mounted
    this.editedEvents = Object.assign([], this.events);
    // get the data if it's on edit mode
    if (this.id) {
      this.isLoading = true;
      let api = `calendars/edit/${this.id}`;
      http.get(api).then(json => {
        let data = json.data;
        this.type.model = data.type;
        this.dates.model = data.dates;
        this.name = data.name;
        for (let i = 0; i < this.userTypes.length; ++i) {
          let userType = this.userTypes[i];
          if (data.user_types.includes(userType.text)) {
            this.userTypes[i].checked = true;
          }
        }
        for (let k in this.departments) {
          let department = this.departments[k];
          let isAllChecked = true;
          department.contents.forEach(content => {
            if (data.id_grades.Elements.includes(content.id)) {
              content.checked = true;
            } else {
              isAllChecked = false;
            }
          });
          if (isAllChecked) {
            department.checked = true;
          }
        }
        // delete the selected events on update
        data.dates.forEach(date => {
          let idx = this.editedEvents.findIndex(i => i.date === date);
          this.$delete(this.editedEvents, idx);
        });
        this.isLoading = false;
      });
    }
  },
  watch: {
    userTypeAll: {
      handler(flag) {
        for (let i = 0; i < this.userTypes.length; ++i) {
          this.userTypes[i].checked = flag;
        }
      }
    },
    'departments.Preschool.checked': {
      handler(n, old) {
        for (let i = 0; i < this.departments.Preschool.contents.length; ++i) {
          this.departments.Preschool.contents[i].checked = n;
        }
      }
    },
    'departments.Primary.checked': {
      handler(n, old) {
        for (let i = 0; i < this.departments.Primary.contents.length; ++i) {
          this.departments.Primary.contents[i].checked = n;
        }
      }
    },
    'departments.Secondary.checked': {
      handler(n, old) {
        for (let i = 0; i < this.departments.Secondary.contents.length; ++i) {
          this.departments.Secondary.contents[i].checked = n;
        }
      }
    }
  },
  methods: {
    deleteEvent() {
      if (confirm(`Are you sure you want to delete this calendar event ?`)) {
        this.isSubmitting = true;
        http.del(`calendars/${this.id}`).then(json => {
          if (json.success) {
            this.$emit('onEventAction', 'Event deleted!');
          } else {
            this.notif = utils.notif('Event deleted!', json);
          }
          this.isSubmitting = false;
        });
      }
    },
    updateEvent() {
      this.isSubmitting = true;
      http.put(`calendars/${this.id}`, this.payload()).then(json => {
        this.isSubmitting = false;
        if (json.success) {
          this.$emit('onEventAction', 'Event updated!');
        } else {
          this.notif = utils.notif('New Calendar Event updated!', json);
        }
      });
    },
    isNew() {
      return this.id === null;
    },
    payload() {
      let payload = {
        name: this.name,
        type: this.type.model,
        dates: this.dates.model,
        user_types: [],
        id_grades: []
      };
      for (let i = 0; i < this.userTypes.length; ++i) {
        let checked = this.userTypes[i].checked;
        if (checked) {
          payload.user_types.push(this.userTypes[i].text);
        }
      }
      for (let k in this.departments) {
        let department = this.departments[k];
        let contents = department.contents;
        for (let i = 0; i < contents.length; ++i) {
          let checked = contents[i].checked;
          if (checked) {
            payload.id_grades.push(contents[i].id);
          }
        }
      }
      return payload;
    },
    submit() {
      this.isSubmitting = true;
      http.post('calendars', this.payload()).then(json => {
        this.isSubmitting = false;
        if (json.success) {
          this.$emit('onEventAction', 'New Calendar Event added!');
        } else {
          this.notif = utils.notif('New Calendar Event added!', json);
        }
      });
    }
  },
  data() {
    return {
      name: '',
      editedEvents: [],
      type: {
        model: 'Public Holiday',
        options: constants.CALENDAR_EVENT_TYPE
      },
      dates: {
        model: [],
        events: []
      },
      userTypeAll: false,
      userTypes: [
        { text: 'Core Admin', checked: false },
        { text: 'Parents', checked: false },
        { text: 'Teachers', checked: false },
        { text: 'Staff', checked: false },
        { text: 'Students', checked: false }
      ],
      departments: {
        Preschool: {
          checked: false,
          contents: [
            { id: 1, text: 'Toddlers', checked: false },
            { id: 2, text: 'PreNursery', checked: false },
            { id: 3, text: 'Nursery', checked: false },
            { id: 4, text: 'Kindergarten 1', checked: false },
            { id: 5, text: 'Kindergarten 2', checked: false }
          ]
        },
        Primary: {
          checked: false,
          contents: [
            { id: 6, text: 'Primary 1', checked: false },
            { id: 7, text: 'Primary 2', checked: false },
            { id: 8, text: 'Primary 3', checked: false },
            { id: 9, text: 'Primary 4', checked: false },
            { id: 10, text: 'Primary 5', checked: false },
            { id: 11, text: 'Primary 6', checked: false }
          ]
        },
        Secondary: {
          checked: false,
          contents: [
            { id: 12, text: 'Grade 7', checked: false },
            { id: 13, text: 'Grade 8', checked: false },
            { id: 14, text: 'Grade 9', checked: false }
          ]
        }
      },
      isSubmitting: false,
      isLoading: false,
      notif: null,
      currentYear: null
    };
  },
  components: {
    CalendarPicker,
    Notif
  }
};
</script>

<style scoped>
.content-summary {
  display: flex;
  flex-flow: column;
}
.period-title {
  font-size: 1em;
  color: rgb(43, 42, 42);
}
.summary-title {
  font-size: 0.9em;
  color: #203368;
  text-transform: uppercase;
  font-weight: bold;
  margin: 10px 0;
}
.summary-group {
  display: flex;
  justify-content: space-between;
}
.summary-elem {
  background-color: rgb(34, 52, 107);
  color: white;
  flex: 1 1 auto;
  height: 100px;
  padding: 10px;
  border-radius: 0.3em;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
.summary-elem:nth-child(even) {
  margin: 0 50px;
}
.footer {
  display: flex;
  justify-content: center;
  padding: 20px;
}
.req-group {
  display: flex;
  flex-flow: column;
}
.req-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.1em;
}
.req-questions {
  margin-top: 10px;
}
.req-question-group {
  display: flex;
  margin-bottom: 10px;
}
.req-question-group.column {
  flex-flow: column;
}
.req-question-group > select {
  height: 32px;
}
.req-question-title {
  min-width: 150px;
  margin-bottom: 10px;
}
.req-control {
  padding: 0.5em;
  border: 1px solid #cecece;
  font-size: 0.9rem;
  border-radius: 0.2rem;
  min-width: 200px;
}
.checkbox-group-with-sub {
  background-color: rgba(222, 226, 222, 0.15);
  padding: 5px;
  margin-right: 10px;
}
/* The container */
.checkbox {
  display: block;
  position: relative;
  padding-left: 35px;
  padding-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.checkbox:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.checkbox input:checked ~ .checkmark {
  background-color: #36d7b7;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
@media screen and (max-width: 640px) {
  .summary-elem:nth-child(even) {
    margin: 0 10px;
  }
  .req-question-group {
    flex-flow: column;
  }
  .req-control {
    flex: 1 1 auto;
  }
}
</style>
